/* eslint-disable linebreak-style */
/* eslint-disable max-len */
/* eslint-disable linebreak-style */

/**
 * Renders the data-test attribute when the input parameter dataTestId is defined.
 * @param dataTestId Value to set in the data-test attribute. If undefined, will attempt to use parameter dataTestIdAlternative instead to render the attribute.
 * @param dataTestIdAlternative Value to set in the data-test attribute. If both dataTestId and dataTestIdAlternative are undefined, the data-test attribute will not render.
 * @returns the data-test attribute or empty.
 */
export const withDataTest = (dataTestId?: string, dataTestIdAlternative?: string) => {
  const value = dataTestId || dataTestIdAlternative;
  const result = value ? { 'data-test': value } : {};

  return result;
};

/**
 * Renders the data-test and data-name attributse when the input parameter dataTestId is defined.
 * @param dataTestId Value to set in the data-test attribute. If undefined, the data-test attribute will not render.
 * @returns the data-test attribute or empty.
 */
export const withDataTestAndDataName = (dataTestId?: string) => (dataTestId ? {
  'data-test': dataTestId,
  'data-name': dataTestId,
} : {});

/**
 * Always renders the data-test attribute.
 * When the input parameter dataTestId is undefined,
 * it will instead use the default value specified by the defaultDataTestId parameter.
 * @param defaultDataTestId
 * @param dataTestId
 * @returns
 */
export const withRequiredDataTest = (defaultDataTestId: string, dataTestId?: string) => {
  const value = dataTestId || defaultDataTestId;

  return withDataTest(value);
};

/**
 * Always renders the data-test and data-name attributes.
 * When the input parameter dataTestId is undefined,
 * it will instead use the default value specified by the defaultDataTestId parameter.
 * @param defaultDataTestId
 * @param dataTestId
 * @returns
 */
export const withRequiredDataTestAndDataName = (defaultDataTestId: string, dataTestId?: string) => {
  const value = dataTestId || defaultDataTestId;

  return withDataTestAndDataName(value);
};
